<template>
  <app-base-main>
    <template #filter-group>
      <ClaimTotalHead
        :totalObj="statData"
        type="returnClaim"/>

      <app-filter-group
          @reset="$gjReset"
          @query="$gjNoticeQuery"
      >
        <gj-country-server-select
            v-model="filter.countryAndMarket"
        ></gj-country-server-select>

        <gj-select
          v-model="filter.claimStatus"
          type="multi-check"
          width="140px"
          :multiple="true"
          :options="[
              {id: 0, text: '未索赔'},
              {id: 2, text: '索赔中'},
              {id: 3, text: '索赔成功'},
              {id: 1, text: '索赔失败'},
              {id: 4, text: '已过期'}
            ]"
          placeholder="索赔状态"
        ></gj-select>
        <gj-select-date-picker
          v-model="filter.date"
          type="daterange"
          :options="[
              {id: 'analysisDate', text: '分析时间'},
              {id: 'caseDate', text: 'Case填写时间'},
          ]"
          :width="['120px']"
        >
        </gj-select-date-picker>
        <gj-select-input
            v-model="filter.keyword"
            :options="[
              {id: 'mskus', text: 'MSKU', moreShow: true},
              {id: 'asins', text: 'ASIN', moreShow: true},
              {id: 'orderIds', text: '订单编号', moreShow: true},
            ]"
        ></gj-select-input>
      </app-filter-group>
    </template>

    <template #operate-group>
      <gj-button
        type="primary"
        @click="inputCase(true, null)"
        :disabled="noSelect"
        v-if="$permission('claim:edit')"
      >
        填写CaseID
      </gj-button>
      <gj-button
        :disabled="noSelect"
        @click="modifyStatus(true)"
        v-if="$permission('claim:edit')"
        >更新索赔状态
      </gj-button>
    </template>

    <template #tool-group>
      <gj-tool-group help>
      </gj-tool-group>
    </template>

    <template #table>
      <gj-table
        ref="gjTable"
        :data="tableData"
        :columns="columns"
        :pagination="pagination"
        :loading="loading"
        :index="false"
        :default-sort="{prop: 'quantity', order: 'descending'}"
        selection
        @sort-change="$gjSortChange"
        @page-change="$gjNoticeQuery"
      >
        <template v-slot:msku="{ row }">
            <gj-tooltip :content="row.msku" :text-line="1">{{ row.msku }}</gj-tooltip>
            <div>
              <gj-link :disabled="!row.asin" :href="row.asinUrl " target="_blank">{{ row.asin || '-' }}</gj-link>
              <span v-copy="row.asin" class="copy-icon gj-cell-display-switch">
                <gj-icon class="el-icon-copy-document"></gj-icon>
              </span>
            </div>
        </template>
        <template v-slot:createTime="{ row }">
          {{row.createTime | formatToDate}}
        </template>
        <template v-slot:claimStatus="{ row }">
            <gj-tag type="text" :color="getColor(row.claimStatus)">{{ getStatusName(row.claimStatus) }}</gj-tag>
            <span v-if="row.claimStatus === 1 && $permission('claim:edit')" @click="modifyStatus(false, row)" class="copy-icon gj-cell-display-switch refresh-icon-color">
              <gj-icon class="el-icon-refresh"></gj-icon>
            </span>
        </template>
        <template v-slot:estimateClaimSingleCost="{ row }">
            <span >{{row.currencySymbol || ''}}{{row.estimateClaimSingleCost | defaultShow}} </span>
        </template>
        <template v-slot:realClaimMoney="{ row }">
            <span >{{row.currencySymbol || ''}}{{row.realClaimMoney | defaultShow}} </span>
        </template>

        <template v-slot:memo="{ row }">
          <template v-if="$permission('claim:edit')">
             <ClaimMemoInput
                :value="row.memo"
                :item="row"
                fixedIcon
                table-cell-edit
                :on-confirm="onConfirm"
                :pop-title="'编辑备注'">
            </ClaimMemoInput>
          </template>
          <template v-else>
            <gj-tooltip :content="row.memo" :textLine="1">{{row.memo}}</gj-tooltip>
          </template>
        </template>
        <template v-slot:op="{ row }">
          <gj-button-group type="dropdown-op">
              <template v-if="$permission('claim:edit')">
                <gj-button type="text" @click="inputCase(false, row)">{{row.caseId ? "修改CaseID" : "填写CaseID"}}</gj-button>
              </template>
            <template  v-if="$permission('claim:edit')">
              <gj-button type="text"  @click="viewTemplate(row)">索赔模板</gj-button>
            </template>
          </gj-button-group>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {responseMixin, queryMixin, selectionMixin} from "@/minxins";
  import ClaimGoodsInputCase from './modal/claim-goods-input-case';
  import ClaimGoodsCaseTemplate from './modal/claim-goods-case-template';
  import ClaimMemoInput from './modal/claim-memo-input';
  import {isMeaningful} from '@/utils/common';
  import {getReturnGoodsClaimPage, getReturnGoodsClaimStat, refreshReturnGoodsClaim, updateReturnGoodsClaim,getReturnGoodsClaimTemplate} from '@/api/sale';
  import { tagColors } from '@/components/tag/tag-colors';
  import ClaimTotalHead from '../claim-total-head';
  import {convertToDate} from "@/utils/date.util";
  import {mapGetters} from "vuex";

  export default {
    name: "claim-return-goods",
    mixins: [queryMixin, selectionMixin, responseMixin],
    components: {
      ClaimTotalHead,
      ClaimMemoInput
    },
    computed:{
      ...mapGetters({
        marketOption: "marketOption",
      }),
    },
    data() {
      return {
        statData:{},
        tagColors,
        timestamp: null,
        tableData: [],
        columns: [
          {id: 'marketId', header: '店铺/国家', field: 'option:marketId', minWidth: '150px',  options: () => this.marketOption, fixed: "left"},
          {id: 'orderId', header: '订单编号', field: 'orderId', minWidth: '180px', fixed: "left"},
          {id: 'imageUrl', header: '图片',  field: 'picture:imageUrl', minWidth: '100px', fixed: "left"},
          {id: 'msku', header: 'MSKU/ASIN', field: 'slot:msku', minWidth: '160px', fixed: "left"},
          {id: 'refundedDate', header: '退货时间', field: 'refundedDate', minWidth: '160px', sortable: true},
          {id: 'createTime', header: '分析日期 ', field: 'slot:createTime', minWidth: '160px', sortable: true, help: '系统分析并生成此条索赔建议的时间'},
          {id: 'shouldReturnQuantity', header: '退货数量 ', field: 'shouldReturnQuantity', minWidth: '140px', sortable: true, align: 'right'},
          {id: 'estimateReturnQuantity', header: '未退回商品 ', field: 'estimateReturnQuantity', minWidth: '140px', sortable: true, align: 'right', help: '亚马逊已赔偿的商品不再计入'},
          {id: 'shouldDamageQuantity', header: '残损商品 ', field: 'shouldDamageQuantity', minWidth: '140px', sortable: true, align: 'right', help: '亚马逊已赔偿的商品不再计入'},
          {id: 'estimateClaimQuantity', header: '预计赔付数量 ', field: 'estimateClaimQuantity', minWidth: '140px', sortable: true, align: 'right', help: '预计赔付数量=未退回商品+残损商品'},
          {id: 'estimateClaimSingleCost', header: '预计赔付金额 ', field: 'slot:estimateClaimSingleCost', minWidth: '140px', sortable: true, align: 'right', help: '按照最近一次赔偿单价计算，最近无赔偿单价为0'},
          {id: 'claimStatus', header: '索赔状态 ', field: 'slot:claimStatus', minWidth: '140px', help: '在您填写caseID后，10天内系统会每天检测《赔偿》报表，更新索赔状态；如超过10天未索赔成功，则自动判别为索赔失败；您可以手动更新索赔状态'},
          {id: 'caseId', header: 'CaseID  ', field: 'caseId', minWidth: '140px'},
          {id: 'claimTime', header: 'case填写时间  ', field: 'claimTime', minWidth: '160px', sortable: true, help: '填写caseID的时间；如修改caseID，则此时间会更新'},
          {id: 'realClaimQuantity', header: '实际赔付库存量 ', field: 'realClaimQuantity', minWidth: '140px', align: 'right', sortable: true},
          {id: 'realClaimCashQuantity', header: '实际赔付金额量 ', field: 'realClaimCashQuantity', minWidth: '140px', align: 'right', sortable: true},
          {id: 'realClaimMoney', header: '实际赔付金额 ', field: 'slot:realClaimMoney', minWidth: '140px', sortable: true, align: 'right'},
          {id: 'memo', header: '备注 ', field: 'slot:memo', minWidth: '178px'},
          {id: 'op ', header: '操作', field: 'slot:op', minWidth: '156px', fixed: 'right', notCustomColumn: true},
        ],

        filter: { 
          claimStatus: [],
          countryAndMarket: null,
          date: {
            key: 'analysisDate', 
            value: null
          },
          keyword: {
            key: 'mskus',
            value: null,
          }
        },
      }
    },
    methods: {
      $gjQuery() {
        this.loading = true;
        this.globalParams = {
          model: {
            marketIds: this.filter.countryAndMarket?.marketIds || null,
            countryCodes: this.filter.countryAndMarket?.countryIds || null,
            claimStatus: this.filter.claimStatus || [] ,
          },
          ...this.queryPagination,
          ...this.querySort,
        };

        if (isMeaningful(this.filter.date.value)){
          const startTime = convertToDate(this.filter.date.value[0]);
          const endTime = convertToDate(this.filter.date.value[1]);
          if (this.filter.date.key === 'analysisDate'){
            this.globalParams.model.createTimeBegin = startTime;
            this.globalParams.model.createTimeEnd = endTime;
          }else if (this.filter.date.key === 'caseDate') {
            this.globalParams.model.caseIdTimeBegin = startTime;
            this.globalParams.model.caseIdTimeEnd = endTime;
          }
        }

        if (isMeaningful(this.filter.keyword.value)) {
          this.globalParams.model[this.filter.keyword.key] = this.filter.keyword.value.split(',') || null;
        }
        getReturnGoodsClaimPage(this.globalParams)
          .then((data) => {
            this.tableData = data.records;
            this.pagination = this.getPagination(data);
          }).complete(() => this.loading = false)
        this.getStat();
      },
      getStat(){
        getReturnGoodsClaimStat(this.globalParams).then((data)=>{
          this.statData = data;
        });
      },
      $gjQueryInitParams() {
        return {
           filter: {
            claimStatus: [],
            countryAndMarket: null,
            date: {
              key: 'analysisDate', 
              value: null
            },
            keyword: {
              key: 'mskus',
              value: null,
            }
          },
        }
      },
      onConfirm(memo, data, closeEditor) {
        updateReturnGoodsClaim({id: [data.id], memo: memo})
          .then(() => {
            this.$gjMessage.success('操作成功');
            this.$gjResetPage();
            closeEditor();
          })
      },
      inputCase(batch, row) {
        let props = {}
        if(batch){
          props = {
            id: this.getSelectRowIDs(),
          }
          if (this.selectedRows && this.selectedRows.length == 1) {
            props.caseId = this.selectedRows[0].caseId || '';
          }
        }else{
          props = {
            id: [row.id],
            caseId: row.caseId
          }
        }
        const modal = this.$gjCreate(ClaimGoodsInputCase, {
          props: props,
          on: {
            after: () => {
              this.$gjResetPage();
              modal.$gjDestroy();
            }
          }
        })
      },
      viewTemplate(row) {
        getReturnGoodsClaimTemplate(row.id).then((data)=>{
          this.$gjCreate(ClaimGoodsCaseTemplate, {
            props: {
              item: row,
              claimTemplate: data
            }
          })
        })
      },
      getColor(status) {
        switch (status) {
          case 0:
            return this.tagColors.violetText;
          case 1:
            return this.tagColors.redText;
          case 2:
            return this.tagColors.orangeText;
          case 3:
            return this.tagColors.greenText;
          case 4:
            return this.tagColors.gray6Text;
        }
      },
      getStatusName(status) {
        let statusName = '';
        switch (status) {
          case 0:
            statusName = '未索赔';
            break;
          case 1:
            statusName = '索赔失败';
            break;
          case 2:
            statusName = '索赔中';
            break;
          case 3:
            statusName = '索赔成功';
            break;
          case 4:
            statusName = '已过期';
            break;
        }
        return statusName;
      },
      modifyStatus(batch, row){
        let ids = null;
        if(batch){
          const selectedItem =  this.selectedRows || [];
          const selectIds = [];
          for (let i = 0; i < selectedItem.length; i ++ ) {
            const claimStatus = selectedItem[i].claimStatus;
            if (claimStatus == 1) {
              selectIds.push(selectedItem[i].id)
            }
          }
          if (selectIds.length == 0) {
            this.$gjMessage.error('当前选中的数据不可更新索赔状态，请选择索赔失败的数据再更新索赔状态');
            return;
          }
          ids = selectIds;
        }else{
          ids = [row.id];
        }
        refreshReturnGoodsClaim(ids).then((data) => {
          if (data){
            this.$gjMessage.success('操作成功！');
            this.$gjQuery();
          }
        });
      },
      getSelectRowIDs(){
        let selectIds = this.selectedRows?.map((item) => {
          return item.id;
        })
        if (!selectIds) {
          selectIds = [];
        }
        return selectIds;
      },

    },
     
  }
</script>

<style scoped>




</style>
